export default (() => {
    const body = document.querySelector("body");
    const lockClassName = "lock";

    if (!body) {
        throw new Error("Body does not exists");
    }

    const scrolling = () => {
        let lastScrollTop = 0;
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st === 0) {
            body.classList.add("top");
        }
        window.addEventListener(
            "scroll",
            function () {
                st = window.pageYOffset || document.documentElement.scrollTop;
                if (body.classList.contains('theme--light')) {
                    const largeHeroSpot = document.querySelector('.large-hero-spot');
                    const spotHeight = largeHeroSpot.offsetHeight;
                    const header = document.querySelector('header')
                    const headerHeight = header.offsetHeight
                    if (st >= spotHeight - headerHeight ) {
                        body.classList.add('past-header');
                    } else {
                        body.classList.remove('past-header');
                    }
                }
                if (st > 300) {
                    body.classList.add('top-300');
                } else {
                    body.classList.remove('top-300');
                }

                if (st < 1) {
                    body.classList.remove("scrolling-down");
                    body.classList.remove("scrolling-up");
                    body.classList.add("top");
                    return;
                }

                if (st > lastScrollTop) {
                    body.classList.add("scrolling-down");
                    body.classList.remove("scrolling-up");
                    body.classList.remove("top");

                    if (st < 150) {
                        body.classList.add("scrolling-down--top");
                    } else {
                        body.classList.remove("scrolling-down--top");
                    }
                } else {
                    body.classList.remove("scrolling-down");
                    body.classList.remove("top");
                    body.classList.add("scrolling-up");
                }
                lastScrollTop = st <= 0 ? 0 : st;
            },
            { passive: true }
        );
    };

    return {
        lock: () => body.classList.add(lockClassName),
        open: () => body.classList.remove(lockClassName),
        scrolling: scrolling,
    };
})();
